/*
 * @Author: your name
 * @Date: 2022-11-18 09:40:20
 * @LastEditTime: 2023-04-23 11:46:51
 * @LastEditors: guozhenqiang 15138913894@163.com
 * @Descripttion: In User Settings Edit
 * @FilePath: /baichuan-website/src/router/index.js
 */
import Vue from "vue";
import Router from "vue-router";
//避免导航冗余
const routerPush = Router.prototype.push;
Router.prototype.push = function (location) {
  return routerPush.call(this, location).catch(error => error);
};
Vue.use(Router);
export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "index",
      component: resolve => require(["@/components/index"], resolve),
      redirect: "/home",
      children: [
        {
          path: "/home",
          name: "home",
          component: resolve => require(["@/components/home"], resolve),
          meta: {
            active: "首页"
          }
        },
        {
          path: "/about/:id",
          name: "about",
          component: resolve => require(["@/components/about"], resolve),
          meta: {
            active: "关于百川"
          }
        },
        {
          path: "/news/:id",
          name: "news",
          component: resolve => require(["@/components/news"], resolve),
          meta: {
            active: "新闻资讯"
          }
        },
        {
          path: "/newsDetail/:id",
          name: "newsDetail",
          component: resolve => require(["@/components/newsDetail"], resolve),
          meta: {
            active: "新闻资讯详情"
          }
        },
        {
          path: "/solution/:id",
          name: "solution",
          component: resolve => require(["@/components/solution"], resolve),
          meta: {
            active: "解决方案"
          }
        },
        {
          path: "/develop/:id",
          name: "develop",
          component: resolve => require(["@/components/develop"], resolve),
          meta: {
            active: "研发中心"
          }
        },
        {
          path: "/culture/:id",
          name: "culture",
          component: resolve => require(["@/components/culture"], resolve),
          meta: {
            active: "企业文化"
          }
        },
        {
          path: "/investor",
          name: "investor",
          component: resolve => require(["@/components/investor"], resolve),
          meta: {
            active: "投资者关系"
          }
        },
        {
          path: "/joinUs/:id",
          name: "joinUs",
          component: resolve => require(["@/components/joinUs"], resolve),
          meta: {
            active: "加入我们"
          }
        },
        {
          path: "/contact",
          name: "contact",
          component: resolve => require(["@/components/contact"], resolve),
          meta: {
            active: "联系我们"
          }
        },
        //英文路由
        {
          path: "/english/home",
          name: "englishHome",
          component: resolve => require(["@/components/english/home"], resolve),
          meta: {
            active: "首页",
            english: true
          }
        },
        {
          path: "/english/about/:id",
          name: "englishAbout",
          component: resolve => require(["@/components/english/about"], resolve),
          meta: {
            active: "关于百川",
            english: true
          }
        },
        {
          path: "/english/solution/:id",
          name: "englishSolution",
          component: resolve => require(["@/components/english/solution"], resolve),
          meta: {
            active: "解决方案",
            english: true
          }
        },
      ]
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js